<template>
  <v-container grid-list-xl class="pa-5">
    <Tenant />
    <v-layout wrap class="pa-5">
      <v-flex xs12 md12>
        <m-card-list
          two-line class=""
          title="Komplain User"
          label-cari="Cari Komplain"
          search
          :items="items"
          :headers="headers"
          refresh
          @refresh="load"
          :page="page"
          footer
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
        >
          <template v-slot:items="{ props, item }">
            <tr v-if="$vuetify.breakpoint.smAndUp">
              <td>{{ pVal(item, "nama") }}</td>
              <td>{{ pVal(item, "tenant") }}</td>
              <td>{{ pVal(item, "detail") }}</td>
              <td v-if="item.k_status">
                <v-chip
                  label
                  outlined
                  :color="$home.statusColor(item.k_status)"
                  >{{ item.k_status ? item.status : "Tidak Diketahui" }}</v-chip
                >
              </td>
              <td>
                <m-menu
                  left
                  style="float:right"
                  :items="more_menu"
                  :object="item"
                />
              </td>
            </tr>
            <tr v-else>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">
                    {{ headers[0].text }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "nama") }}
                  </div>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">
                    {{ headers[1].text }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "tenant") }}
                  </div>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">
                    {{ headers[2].text }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ pVal(item, "detail") }}
                  </div>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">
                    {{ headers[3].text }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    <v-chip
                      outlined
                      :color="$home.statusColor(item.k_status)"
                      >{{
                        item.k_status ? item.status : "Tidak Diketahui"
                      }}</v-chip
                    >
                  </div>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">
                    {{ headers[4].text }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    <m-menu
                      left
                      style="float:right"
                      :items="more_menu"
                      :object="item"
                    />
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </m-card-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BlockCard from "@/components/BlockCard";
import MChartLine from "@/components/MChartLine";
import MChartPie from "@/components/MChartPie";
import Tenant from "../../tenant/pages/List";

export default {
  components: {
    BlockCard,
    MChartLine,
    MChartPie,
    Tenant
  },
  data() {
    return {
      stat: {},
      page: null,
      page2: null,
      cp: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Tenant", align: "left", value: "tenant" },
        { text: "Detail", align: "left", value: "detail" },
        { text: "Status", sortable: false, value: "status" },
        { text: "", sortable: false }
      ],
      items: [],
      more_menu: [
        { divider: true },
        // eslint-disable-next-line
        {
          title: "Set Resolved",
          click: this.load
        },
        { divider: true }
      ],
      sumber: {
        legend: ["NEW", "IN PROGRESS", "RESOLVED"],
        data: [
          { value: 5, name: "NEW" },
          { value: 7, name: "IN PROGRESS" },
          { value: 9, name: "RESOLVED" }
        ]
      }
    };
  },
  mounted() {
    // this.loadStatistik();
    // this.loadPendapatan();
  },
  computed: {},
  methods: {
    load() {},
    // loadTenant() {},
    loadStatistik() {
      this.$store.dispatch("laporan/statistik").then(res => {
        this.stat = res.data;
      });
    },
    loadRekap() {
      this.$store.dispatch("laporan/sumberRekapNow").then(res => {
        this.sumber.data = [
          { value: res.data.motor, name: "Roda 2" },
          { value: res.data.mobil, name: "Roda 4" }
        ];
      });
    }
    // loadPendapatan(){
    //   this.$store.dispatch("laporan/pendapatan").then(res => {
    //     this.pendapatan = res.data;
    //   });
    // }
  }
};
</script>
